export const BUTTONS = {
    SUBMIT: "Submit",
    SEARCH: "Search",
    RESET: "Reset",
    REMOVE: "Remove",
    SAVE: "Save",
    SAVE_DRAFT: "Save Draft",
    SAVE_DOCUMENT_NAME: "Save Name",
    SAVING: "Saving...",
    SAVE_AND_CONTINUE: "Save & Activate",
    VALIDATE: "Validate Content",
    VALIDATING: "Validating...",
    CLOSE: "Close",
    SEND: "SEND",

    SENDING: "SENDING",
    CONTINUE: "CONTINUE",
    ADD: "Add",
    ADDING: "Adding...",
    CANCEL: "Cancel",
    VERIFY: "Verify",
    VERIFYING: "VERIFYING...",
    LOADING: "Loading",
    SEND_REQUEST: "Send Request"
};

export const MESSAGE = {
    MAX_VALUE_REACHED: "Maximum number of items reached.",
    MAX_PAGE_REACHED: "Maximum 10 pages are allowed",
    MIN_PAGE_REACHED: "Minimum 1 pages are allowed",
    SAVED: "Data Saved Successfully",
    VALIDATED: "Validated successfully",
    REQUEST_ACCESS: "To proceed, we need the candidate’s consent to disclose their information.\nThe candidate will receive a notification via message or email requesting their authorization.",
    DRAFT_SAVED: "Draft Saved Successfully",
    SAVED_LOCALLY: "Your changes are not saved. please SAVE to avoid data loss.",
    DEFAULT_ERROR_MESSAGE: "Something went wrong. Please try again later",
    INVALID_TAG: "The Tags [{0}] are invalid",
    TAG_LEFT: "The tags [{0}] are missing",
    COULD_NOT_ACTIVATE: " Document is still in draft.",
    DOCUMENT_ALREADY_ISSUED: "Document already Issued",
    SELECT_SUPPORT_DOCUMENT_DROPDOWN: "No Document Required",
    NO_DATA_TO_SAVE: "Please add some data to proceed",
    REQUEST_SENT: 'Added to cart successfully',
    DEFAULT_ERROR_MESSAGE: 'Something Went Wrong, please try again',
    PLACEHOLDER: 'Start typing...',
    QR_LENGTH_REACHED:"You cannot add more than one QR"
};

export const LAYOUT_TEXT = {
    ADD_MORE_PAGE: "+ Pg",
    REMOVE_PAGE: "- Pg",
    ADD_TO_DESIGN: "+ Add to Design",
    INSERT_TAGS: "Insert Tags",
    EDITOR_HEADING: "Select any component to start editing"
}

export const TITLE = {
    Home: "Home",
    Profile: "Profile",
    Layout: "Layout"
}

export const STATUS = {
    CREATED: "Created",
    DROPPED: "Marked Dropped",
    ACTIVATED: "Activate",
    DEACTIVATED: "de-activate",
    DRAFT: "Draft",
    PENDING: "Pending",
    COMPLETED: "Completed",
    ISSUED: "Issued",
    DONE: "Done",
    REVOKED: "Revoked",

    DOCUMENT_CREATED: "DOCUMENT_CREATED",
    TAG_MAPPING: "TAG_MAPPING",
    DESIGN: "DESIGN",
    UNCONFIRMED: "UNCONFIRMED",
    INACTIVE: "INACTIVE",
    ISSUED: "Issued",
    ACTIVE: "ACTIVE"
}

export const APP_NAME = 'AuthNumber'
